import { BaseModel, attr} from "../../lib/itn-ui-kit/data";

export default class ProviderModel extends BaseModel {
    static urlPath = 'provider';

    @attr('string') name;
    @attr('string') phone;
    @attr('boolean') inNetwork;
    @attr('array') providerTypes;
    @attr('string') createdByName;
    @attr('boolean') receivingClients;
    @attr('boolean') acceptingFunding;
    @attr('datetime') createdAt;
    @attr('datetime') updatedAt;
}